module.exports = __webpack_public_path__ + "assets/formosa.5c26dcae.svg";